import { useTranslations } from 'next-intl';

import { BaseFieldProps } from '@/fo/ui/kit/field/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { UiKitTextareaBase } from '@/fo/ui/kit/textarea/base';

import { styles } from './AboutProductSection.styles';

export interface AboutProductSectionProps {
  getFieldProps: (name: string) => BaseFieldProps;
}

export function AboutProductSection({
  getFieldProps
}: AboutProductSectionProps) {
  const slots = styles();
  const t = useTranslations('review.form.aboutProduct');

  return (
    <div className={slots.base()}>
      <UiKitInputBase
        label={t('pros.label')}
        placeholder={t('pros.placeholder')}
        {...getFieldProps('pros')}
      />
      <UiKitInputBase
        label={t('cons.label')}
        placeholder={t('cons.placeholder')}
        {...getFieldProps('cons')}
      />
      <UiKitTextareaBase
        label={t('comment.label')}
        placeholder={t('comment.placeholder')}
        {...getFieldProps('text')}
      />
    </div>
  );
}
